import { RouteObject } from 'react-router-dom';
import { AccessLevelManagement } from './views/AccessLevelManagement';

export const accessLevelRoutes: RouteObject[] = [
    {
        path: '/admin/nub/access-levels',
        element: <AccessLevelManagement />,
    }
];